export default {
 ADMIN: 'Admin',
 DRIVER: 'Driver',
 ACCOUNTING: 'Accounting',
 MANAGER: 'MANAGER',
 CUSTOMER: 'CUSTOMER',
 GUEST: 'GUEST'
};
